<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <ApiGuideAuthForm/>
    </main>
</template>
<script>
import ApiGuideAuthForm from '@/components/apiGuide/ApiGuideAuthForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "API 연계가이드" },
            ],
        };
    },
    components: {
        ApiGuideAuthForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>